/* eslint-disable */
import libraries from "../arduino/libraries";

export default function init(Blockly, profile) {
  Blockly.Arduino.lists = {};

  // oJo, aislar listas en definitions_var_l? e implentar un generador en el core

  Blockly.Arduino.lists_create_with_number = function() {
      this.getFieldValue("TYPE");

      var code;
      var listName = Blockly.Arduino.nameDB_.getName(this.getFieldValue("VARLISTNUM"), Blockly.VARIABLE_CATEGORY_NAME);
      var nItems = this.itemCount_;
      var elements = Array(this.itemCount_);
      for (var i = 0; i < nItems; i++) {
            elements[i] = Blockly.Arduino.valueToCode(this, "ADD" + i, Blockly.Arduino.ORDER_NONE) || "0";
          }

      // list definition
      code = "\ndouble " + listName + "[" + nItems + "] = {" + elements.join(", ") + "};"
      Blockly.Arduino.definitions_["var_ld_" + listName] = code;

      // list length definition
      code = "int " + listName + "_size = " + nItems + ";"
      Blockly.Arduino.definitions_["var_ld_" + listName + "_size"] = code;

      // return noting
      return "";
  };

  Blockly.Arduino.lists_create_with_text = function() {
      this.getFieldValue("TYPE");

      var code;
      var listName = Blockly.Arduino.nameDB_.getName(this.getFieldValue("VARLISTTEXT"), Blockly.VARIABLE_CATEGORY_NAME);
      var nItems = this.itemCount_;
      var elements = Array(this.itemCount_);
      for (var i = 0; i < nItems; i++) {
            elements[i] = Blockly.Arduino.valueToCode(this, "ADD" + i, Blockly.Arduino.ORDER_NONE) || 'String("")';
          }

      // list definition
      code = "\nString " + listName + "[" + nItems + "] = {" + elements.join(", ") + "};"
      Blockly.Arduino.definitions_["var_ls_" + listName] = code;

      // list length definition
      code = "int " + listName + "_size = " + nItems + ";"
      Blockly.Arduino.definitions_["var_ls_" + listName + "_size"] = code;

      // return noting
      return "";
  };

  Blockly.Arduino.lists_getIndex_number = function() {
      var code;
      var listName = Blockly.Arduino.nameDB_.getName(this.getFieldValue("VARLISTNUM"), Blockly.VARIABLE_CATEGORY_NAME);
      var index = Blockly.Arduino.valueToCode(this, "AT", Blockly.Arduino.ORDER_ADDITIVE) || "0";

      index.match(/^\d+$/) && (index = parseInt(index, 10));
      code = "" + listName + "[(int)(" + index + ")]";
      return [code, Blockly.Arduino.ORDER_ATOMIC];
  };

  Blockly.Arduino.lists_getIndex_text = function() {
      var code;
      var listName = Blockly.Arduino.nameDB_.getName(this.getFieldValue("VARLISTTEXT"), Blockly.VARIABLE_CATEGORY_NAME);
      var index = Blockly.Arduino.valueToCode(this, "AT", Blockly.Arduino.ORDER_ADDITIVE) || "0";

      index.match(/^\d+$/) && (index = parseInt(index, 10));
      code = "" + listName + "[(int)(" + index + ")]";
      return [code, Blockly.Arduino.ORDER_ATOMIC];
  };

  Blockly.Arduino.lists_setIndex_number = function() {
      var listName = Blockly.Arduino.nameDB_.getName(this.getFieldValue("VARLISTNUM"), Blockly.VARIABLE_CATEGORY_NAME);
      var index = Blockly.Arduino.valueToCode(this, "AT", Blockly.Arduino.ORDER_ADDITIVE) || "0";
      var value = Blockly.Arduino.valueToCode(this, "TO", Blockly.Arduino.ORDER_ASSIGNMENT) || "0";
      index.match(/^\d+$/) && (index = parseInt(index, 10));
      return "" + listName + "[(int)(" + index + ")] = " + value + ";\n"
  };

  Blockly.Arduino.lists_setIndex_text = function() {
      var listName = Blockly.Arduino.nameDB_.getName(this.getFieldValue("VARLISTTEXT"), Blockly.VARIABLE_CATEGORY_NAME);
      var index = Blockly.Arduino.valueToCode(this, "AT", Blockly.Arduino.ORDER_ADDITIVE) || "0";
      var value = Blockly.Arduino.valueToCode(this, "TO", Blockly.Arduino.ORDER_ASSIGNMENT) || "0";
      index.match(/^\d+$/) && (index = parseInt(index, 10));
      return "" + listName + "[(int)(" + index + ")] = " + value + ";\n"
  };

  Blockly.Arduino.lists_length_number = function() {
      var listName = Blockly.Arduino.nameDB_.getName(this.getFieldValue("VARLISTNUM"), Blockly.VARIABLE_CATEGORY_NAME);
      var code = listName + "_size";
      return [code, Blockly.Arduino.ORDER_ATOMIC];
  };

  Blockly.Arduino.lists_length_text = function() {
      var listName = Blockly.Arduino.nameDB_.getName(this.getFieldValue("VARLISTTEXT"), Blockly.VARIABLE_CATEGORY_NAME);
      var code = listName + "_size";
      return [code, Blockly.Arduino.ORDER_ATOMIC];
  };
};
